// extracted by mini-css-extract-plugin
module.exports = {"yj-font-style":"yj-font-style--2xgC5","NotFoundPage":"NotFoundPage--kHWlM"};